import { Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_40bbf581-5235-4696-9bdc-3ce549288854/artifacts/onxdn5ml_PBlogo.jpg";
const PHONE_NUMBER = "+15054727064";
const PHONE_DISPLAY = "(505) 472-7064";

export const Header = () => {
  return (
    <header className="absolute top-0 left-0 right-0 z-50 bg-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center" data-testid="header-logo">
            <img 
              src={LOGO_URL} 
              alt="Prime Baths of NM" 
              className="h-14 w-auto"
            />
          </a>
          
          {/* Phone CTA */}
          <a 
            href={`tel:${PHONE_NUMBER}`}
            className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-white hover:bg-white/20 transition-colors duration-300"
            data-testid="header-phone"
          >
            <Phone className="h-4 w-4" />
            <span className="font-semibold text-sm sm:text-base">{PHONE_DISPLAY}</span>
          </a>
        </div>
      </div>
    </header>
  );
};
